import { render } from "./PhotoViever.vue?vue&type=template&id=30400e6f&scoped=true&ts=true"
import script from "./PhotoViever.vue?vue&type=script&lang=ts"
export * from "./PhotoViever.vue?vue&type=script&lang=ts"

import "./PhotoViever.vue?vue&type=style&index=0&id=30400e6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30400e6f"]])

export default __exports__